import { render, staticRenderFns } from "./BlackbookShow.vue?vue&type=template&id=176a8990&scoped=true&"
import script from "./BlackbookShow.vue?vue&type=script&lang=js&"
export * from "./BlackbookShow.vue?vue&type=script&lang=js&"
import style0 from "./BlackbookShow.vue?vue&type=style&index=0&id=176a8990&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176a8990",
  null
  
)

export default component.exports